<template>
  <div class="profile-image" :class="sizeClass">
    <img :src="user.profileImage.url" :title="title" :alt="title" :class="imageClass">
    <div v-if="user.profileImage.isDefault && !suppressInitials" class="initials">
      {{ user.initials }}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    imageClass: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false,
      default: 'sm'
    },
    suppressInitials: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    sizeClass() {
      switch (this.size) {
      case 'xs':
      case 'sm':
      case 'md':
      case 'lg':
        return `profile-image-${this.size}`
      default:
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .profile-image {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .initials {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-weight: bold;
  }

  .profile-image-xs {
    font-size: 8px;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .profile-image-sm{
    font-size: 14px;

    img {
      width: 30px;
      height: 30px;
    }
  }

  .profile-image-md{
    font-size: 16px;

    img {
      width: 50px;
      height: 50px;
    }
  }

  .profile-image-lg {
    font-size: 20px;

    img {
      width: 70px;
      height: 70px;
    }
  }
</style>
